import { setting } from '../api/entities';

export const actions = {
  listSetting: 'LIST_SETTING',
};

export function getSettings() {
  return setting.list(actions.listSetting, null, null, true);
}

const INITIAL_STATE = {
  settings: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listSetting:
      return {
        ...state,
        settings: action.body ? action.body._items : state.settings,
      };
    default:
      return {
        ...state,
      };
  }
}
